import { render, staticRenderFns } from "./FormRegisterContact.vue?vue&type=template&id=22b4a849&scoped=true&"
import script from "./FormRegisterContact.vue?vue&type=script&lang=js&"
export * from "./FormRegisterContact.vue?vue&type=script&lang=js&"
import style0 from "./FormRegisterContact.vue?vue&type=style&index=0&id=22b4a849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b4a849",
  null
  
)

export default component.exports